import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import './Navbar.css';
import Logo from '../assets/logo.png';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [servicesDropdown, setServicesDropdown] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <img src={Logo} alt="AtelierbyShriji" />
        </Link>
        <div className="menu-icon" onClick={toggleMenu}>
          {menuOpen ? <FaTimes color="#3e1c00" /> : <FaBars color="#3e1c00" />}
        </div>

        <ul className={menuOpen ? 'nav-menu active' : 'nav-menu'}>
          <li className="nav-item">
            <Link to="/" className="nav-links" onClick={closeMenu}>Home</Link>
          </li>
          <li className="nav-item">
            <Link to="/about" className="nav-links" onClick={closeMenu}>About Us</Link>
          </li>
          <li className="nav-item">
            <Link to="/our-work" className="nav-links" onClick={closeMenu}>Our Work</Link>
          </li>

          <li className="nav-item dropdown">
            <span className="nav-links" onClick={() => setServicesDropdown(!servicesDropdown)}>
              Services ▾
            </span>
            <div className={`dropdown-menu ${servicesDropdown ? 'show' : ''}`}>
              <div className="dropdown-column">
                <Link to="/bridal-makeup" onClick={closeMenu}>Bridal Makeup</Link>
                <Link to="/groom" onClick={closeMenu}>Groom Makeup</Link>
                <Link to="/party-makeup" onClick={closeMenu}>Party Makeup</Link>
                <Link to="/editorial-makeup" onClick={closeMenu}>Editorial Makeup</Link>
                <Link to="/makeup-courses" onClick={closeMenu}>Makeup Courses</Link>
                <Link to="/tutorials" onClick={closeMenu}>Makeup Tutorials</Link>
              </div>
              {/* <div className="dropdown-column">
                
                
              </div> */}
            </div>
          </li>

          <li className="nav-item">
            <Link to="/blog" className="nav-links" onClick={closeMenu}>Blog</Link>
          </li>
          <li className="nav-item">
            <Link to="/contact" className="nav-links" onClick={closeMenu}>Contact Us</Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;